import { pickBy, pick } from "lodash";

export function valueToArray(value) {
    if (value == null) return [];
    return Array.isArray(value) ? value.map(item => item.toString()) : [value.toString()];
}

export function formatDate(date) {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export function downloadFile(filename, text) {
    const element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

export function filterOptionsByQuery(options, query, selectedOptions, fieldGetter) {
    return options.filter((option) => {
        return fieldGetter(option) && fieldGetter(option)
                .toString()
                .toLowerCase()
                .indexOf(query.toLowerCase()) >= 0 &&
            !selectedOptions.includes(option)
    })
}

export function generateNewJiraIssueUrl(url, pid, issueType, summary) {
    return `${url}/secure/CreateIssueDetails!init.jspa?pid=${pid}&issuetype=${issueType}&summary=${encodeURI(summary)}&priority=3`;
}

export function extractParams(filters = {}, allowed = []) {
    return pickBy(pick(filters, allowed), v => v != null)
}
